<template>
  <div class="book-list" v-if="defaultShow">
    <div class="demo-book-box" v-for="(item, index) in dataList" :key="index">
      <div class="left-book" @click="toDetail(item.resourceId)">
        <el-image class="img_box" :src="item.resourceCover">
          <div slot="error" class="image-slot">
            <img class="img_box" src="../assets/images/default_img.jpg" />
          </div>
        </el-image>
      </div>
      <div class="right-book-info">
        <div class="book-title">
          <div class="book-label">课程</div>
          <el-tooltip
            :content="item.resourceName"
            placement="top"
            v-ak-tooltip-auto-show
          >
            <div class="title" @click="toDetail(item.resourceId)">
              {{ item.resourceName }}
            </div>
          </el-tooltip>
        </div>
        <div class="label" v-if="item.keyword != null">
          <span v-for="(item, index) in item.keyword.split(',')" :key="index">{{
            item
          }}</span>
        </div>
        <div class="course">
          共{{ item.courseNumber || "0" }}节课 {{ item.paperNumber || "0" }}套题
        </div>
        <div class="seeNum">
          <img src="../assets/icon/eye.png" />
          <div>{{ item.viewerNumber | formatNumber }}</div>
        </div>
        <div class="price">
          <span>
            {{ item.realPrice | tofixed2("￥") }}
          </span>
          <span
            v-if="item.prices > 0"
            :class="item.prices == 0 ? 'yprice2' : 'yprice'"
            >{{ item.prices | tofixed2("￥") }}</span
          >
        </div>
        <div class="time">
          有效期：
          <span style="margin-left: 10rpx" v-if="item.isValidForever != 0">
            截止到{{ formatDate(item.validEndDate) }}</span
          >
          <span style="margin-left: 10rpx" v-if="item.isValidForever == 0"
            >永久</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyWord: [],
      defaultShow: true,
    };
  },
  props: {
    dataList: Array,
    showBook: Boolean,
    subjectId: String,
    showEditor: Boolean,
    payType: String,
    goodsTypeList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    showBook() {
      //专题详情图书的收起
      this.defaultShow = this.showBook;
    },
  },
  methods: {
    toDetail(id) {
      let routeUrl = this.$router.resolve({
        path: "/willingLearn/bookstoreDetail",
        query: {
          goodsId: id,
          goodsType: "train",
          source: "willing",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    formatDate(time) {
      var date = new Date(time);
      var year = date.getFullYear(),
        month = date.getMonth() + 1, //月份是从0开始的
        day = date.getDate(),
        hour = date.getHours(),
        min = date.getMinutes(),
        sec = date.getSeconds();
      var newTime =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day);
      //  + ' ' +
      // (hour < 10 ? '0' + hour : hour) + ':' +
      // (min < 10 ? '0' + min : min) + ':' +
      // (sec < 10 ? '0' + sec : sec);
      return newTime;
    },
  },
};
</script>
<style scoped lang='scss'>
.book-list {
  margin-top: 15px;
  .demo-book-box {
    display: flex;
    padding-bottom: 15px;
    border-bottom: 1px solid #f2f2f2;
    margin-bottom: 15px;
    .left-book {
      width: 260px;
      height: 260px;
      background: #fbfbfb;
      border: 1px solid #f2f2f2;
      border-radius: 6px;
      margin-right: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right-book-info {
      width: 750px;
      .book-title {
        display: flex;
        align-items: center;
        height: 24px;
        margin-bottom: 20px;
        .book-label {
          padding: 0 15px;
          height: 24px;
          background: #f9fdff;
          border: 1px solid #0081ce;
          border-radius: 6px;
          text-align: center;
          line-height: 24px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #0081ce;
          margin-right: 10px;
          box-sizing: border-box;
        }
        .title {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          max-width: 600px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        .title:hover {
          color: #1690ff;
          text-decoration: underline;
        }
      }
      .author-p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-bottom: 14px;
      }
      .label {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        flex-wrap: wrap;
        span {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          background: #f2f2f2;
          border-radius: 6px;
          padding: 7px 10px;
          margin-right: 16px;
          box-sizing: border-box;
          display: block;
          margin-bottom: 20px;
        }
        span:last-child {
          margin-right: 0;
        }
      }
      .course {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #2e9adb;
        line-height: 9px;
        margin-bottom: 20px;
      }
      .seeNum {
        margin-bottom: 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 14px;
        display: flex;
        flex-direction: row;
        align-items: center;
        img {
          width: 20px;
          height: 16px;
          margin-right: 10px;
        }
      }
      .price {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ff5353;
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        .yprice {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          text-decoration: line-through;
          color: #999999;
          margin-left: 10px;
        }
        .yprice2 {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          text-decoration: line-through;
          margin-left: 10px;
        }
      }
      .time {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #70b603;
        line-height: 20px;
      }
    }
  }
  .demo-book-box:last-child {
    margin: 0;
    border: none;
    padding: 0;
  }
}
.img_box {
  width: 100%;
  height: 100%;
  background-position: center center;
  background-size: cover;
  background: #fff;
}
</style>
